// eslint-disable-next-line import/prefer-default-export
export const ACCEPTED_CURRENCIES = ['usd', 'eur', 'chf']
